import { create } from "zustand";

/** Loaded sibling-book manuscripts for the # mention picker (TipTap suggestion runs outside normal React tree). */
export type MentionComposerSeriesBookDoc = {
  id: string;
  title?: string;
  bookProjectId: string;
  bookTitle?: string;
};

type Store = {
  seriesBookDocuments: MentionComposerSeriesBookDoc[];
  setSeriesBookDocuments: (docs: MentionComposerSeriesBookDoc[]) => void;
};

export const useMentionComposerSeriesDocsStore = create<Store>((set) => ({
  seriesBookDocuments: [],
  setSeriesBookDocuments: (seriesBookDocuments) => set({ seriesBookDocuments }),
}));
